import React, {useEffect, useState} from 'react';

//import * as LogFunctions from './../Helpers/LogFunctions';
import {
    ActivityIndicator,
    AlertModal,
    CCText,
    Modal,
    TouchableNativeFeedback,
    View
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';

import ChocoForm from '../../../custom-packages/react-chocoforms/legacy/ChocoForm';
import AppConfig from '../../../AppConfig';

import {useSelector} from 'react-redux';

import TRestaurantEditorScreen from './Translations/TRestaurantEditorScreen';
import {BorderlessButton, ThemeButton} from "../../../custom-packages/react-button-package/ButtonPackage";
import ActivityIndicatorWrapper from '../../public/UI/ActivityIndicatorWrapper';
import Styles from '../../../Styles';

const RestaurantEditorModal = (props) => {
    const auth = useSelector(state => state.Auth)
    const id = props.id

    const [countries, setCountries] = useState(props.countries)
    const [states, setStates] = useState(props.states)

    const countriesSetup = () => {
        const options = [];

        for (let i = 0; i < countries.length; i++)
            options.push({
                label: countries[i].coU_NAME,
                value: countries[i].coU_ID
            });

        return options;
    }

    const statesSetup = () => {
        const options = [];

        for (let i = 0; i < states.length; i++)
            options.push({
                label: states[i].stA_NAME,
                value: states[i].stA_ID
            });

        return options;
    }

    const [loading, setLoading] = useState(true)
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true)
    const [saving, setSaving] = useState(false)
    const [restaurant, setRestaurant] = useState(null)
    const [restaurantWeekdays, setRestaurantWeekdays] = useState([]);
    const [form, setForm] = useState({
        controls: {
            RES_NAME: {
                elementType: 'input',
                label: TRestaurantEditorScreen[AppConfig.lang].NAME,
                elementConfig: {
                    type: 'text',
                    placeholder: TRestaurantEditorScreen[AppConfig.lang].NAME,
                    autoCapitalize: 'sentences'
                },
                value: '',
                validation: {
                    required: true
                },
            },
            RES_COUNTRY_ID: {
                elementType: 'select',
                elementConfig: {
                    placeholder: TRestaurantEditorScreen[AppConfig.lang].COUNTRY,
                },
                label: TRestaurantEditorScreen[AppConfig.lang].COUNTRY + '*',
                value: '',
                options: countriesSetup(),
                errorMessage: '',
                validation: {
                    required: true
                },
                onChangeCallback: async (event) => {
                    let controls = {...form.controls}
                    setForm({
                        controls,
                        isValidForm: false
                    })
                    setSaveButtonDisabled(true)
                    const response = await fetch(AppConfig.URL + '/PublicActions/FetchStates/' + event.value, {
                            method: 'GET',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                            },
                        }
                    );

                    let data = await response.json();

                    controls = {...form.controls}
                    const RES_STATE_ID = {...controls.RES_STATE_ID}

                    RES_STATE_ID.value = ""
                    RES_STATE_ID.options = []

                    for (let i = 0; i < data.states.length; i++)
                        RES_STATE_ID.options.push({
                            label: data.states[i].stA_NAME,
                            value: data.states[i].stA_ID
                        });

                    controls.RES_STATE_ID = RES_STATE_ID;
                    controls.RES_COUNTRY_ID.value = event.value;

                    setForm({
                        controls
                    })
                    setStates(data.states)
                }
            },
            RES_STATE_ID: {
                elementType: 'select',
                label: TRestaurantEditorScreen[AppConfig.lang].STATE + '*',
                elementConfig: {
                    multiline: true,
                    type: 'text',
                    placeholder: TRestaurantEditorScreen[AppConfig.lang].STATE,
                    autoCapitalize: 'sentences'
                },
                value: '',
                options: statesSetup(),
                validation: {
                    required: true
                },
            },
            RES_CITY: {
                elementType: 'input',
                label: TRestaurantEditorScreen[AppConfig.lang].CITY + '*',
                elementConfig: {
                    multiline: true,
                    type: 'text',
                    placeholder: TRestaurantEditorScreen[AppConfig.lang].CITY,
                    autoCapitalize: 'sentences'
                },
                value: '',
                validation: {
                    required: true
                },
            },
            RES_LOCATION: {
                elementType: 'input',
                label: TRestaurantEditorScreen[AppConfig.lang].LOCATION + '*',
                elementConfig: {
                    multiline: true,
                    type: 'text',
                    placeholder: TRestaurantEditorScreen[AppConfig.lang].LOCATION,
                    autoCapitalize: 'sentences'
                },
                value: '',
                validation: {
                    required: true
                },
            },
            RES_DESCRIPTION: {
                elementType: 'input',
                label: TRestaurantEditorScreen[AppConfig.lang].DESCRIPTION,
                elementConfig: {
                    type: 'text',
                    placeholder: TRestaurantEditorScreen[AppConfig.lang].DESCRIPTION,
                    autoCapitalize: 'sentences'
                },
                value: '',
                validation: {
                    required: false
                },
            },
        },
    })

    const fetchData = async () => {
        setLoading(true);
        const controls = {...form.controls};

        const response = await fetch(AppConfig.URL + "/Restaurant/EditorData/" + id, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': auth.token
            }
        });

        const json = await response.json();


        const statesResponse = await fetch(AppConfig.URL + '/PublicActions/FetchStates/' + json.restaurant.countryID, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        let statesData = await statesResponse.json();

        for (let i = 0; i < statesData.states.length; i++)
            controls.RES_STATE_ID.options.push({
                label: statesData.states[i].stA_NAME,
                value: statesData.states[i].stA_ID
            });

        setStates(statesData.states)

        controls.RES_NAME.value = json.restaurant.reS_NAME;
        controls.RES_COUNTRY_ID.value = json.restaurant.countryID;
        controls.RES_STATE_ID.value = json.restaurant.reS_STATE_ID;
        controls.RES_CITY.value = json.restaurant.reS_CITY;
        controls.RES_DESCRIPTION.value = json.restaurant.reS_DESCRIPTION;
        controls.RES_LOCATION.value = json.restaurant.reS_LOCATION;

        setLoading(false)
        setRestaurant(json.restaurant)
        setRestaurantWeekdays(json.restaurantWeekdays)
        setForm({
            controls
        })
    }

    useEffect(() => {
        if (!props.visible)
            return;

        fetchData()
    }, [props.visible])

    if (loading) {
        return <Modal
            visible={props.visible}
            onRequestClose={props.onRequestClose}
        >
            <ActivityIndicatorWrapper style={{marginTop: 50, marginBottom: 50}}/>
        </Modal>
    }

    return <Modal
        visible={props.visible}
        onRequestClose={props.onRequestClose}
    >
        <View style={{marginTop: 10}}>
            <View>
                <ChocoForm
                    containerStyle={{padding: 0}}
                    lang={AppConfig.lang}
                    form={form}
                    onFormChange={(updatedForm) => {
                        setForm(updatedForm)
                        setSaveButtonDisabled(!updatedForm.isValidForm)
                    }}
                />
                <View style={{flexDirection: 'row', justifyContent: 'flex-end'}}>
                    {saving ?
                        <ActivityIndicator style={{marginRight: 7}}/>
                        :
                        null
                    }
                    <ThemeButton
                        disabled={saveButtonDisabled}
                        text={TRestaurantEditorScreen[AppConfig.lang].SAVE}
                        onPress={async () => {
                            if (form.isValidForm) {
                                setSaving(true)
                                setSaveButtonDisabled(true)

                                let formData = {};

                                formData['RES_ID'] = id;

                                for (let key in form.controls) {
                                    formData[key] = form.controls[key].value;
                                }

                                const response = await fetch(AppConfig.URL + '/Restaurant/Create/', {
                                    method: 'POST',
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                        'Authorization': auth.token
                                    },
                                    body: JSON.stringify(formData)
                                });

                                const data = await response.json();

                                if (data.success) {
                                    const eventData = data.restaurant;

                                    props.onDataChange({eventData})
                                }

                                setSaving(false)
                            } else {

                            }
                        }}
                    />
                </View>
            </View>
            <h4 style={{marginTop: 25}}>
                {TRestaurantEditorScreen[AppConfig.lang].SERVICE_TIME}
            </h4>
            <ServiceTimeSection
                restaurantWeekdays={restaurantWeekdays}
                RestaurantID={id}
                Auth={auth}
            />
        </View>
    </Modal>;
}

export default RestaurantEditorModal;

const ServiceTimeSection = (props) => {
    const TServiceTimeSection = {
        // English
        "enUS": {
            'NEW_SERVICE_TIME': "New service time",
            'APPLICABLE_DAYS': "Applicable days",
            'DONT_OPEN_DAY': "The restaurant won't be open this day",
            'SET_TIME': "Edit service times",
            'REMOVE_TIME': "Remove",
            'SAVE': "Save",
            'CANCEL': "Cancel",
            'OPENS': "Opens",
            'CLOSES': "Closes",
            'OPENS_AT': "Opens at",
            'CLOSES_AT': "and closes at",
            'SUN': "Sunday",
            'MON': "Monday",
            'TUE': "Tuesday",
            'WED': "Wednesday",
            'THU': "Thursday",
            'FRI': "Friday",
            'SAT': "Saturday",
            'SU': 'S',
            'MO': 'M',
            'TU': 'T',
            'WE': 'W',
            'TH': 'T',
            'FR': 'F',
            'SA': 'S',
            'REMOVE_TIME_TEXT': "If you remove the service times of this day, the restaurant won't be shown as open in the app during this day",
            'REMOVE': "Remove",
            'SAVING': "Saving...",
        },
        // Spanish
        "esMX": {
            'NEW_SERVICE_TIME': "Nuevo horario",
            'APPLICABLE_DAYS': "Días aplicables",
            'DONT_OPEN_DAY': "El restaurante no estará abierto este día",
            'SET_TIME': "Editar horarios de servicio",
            'REMOVE_TIME': "Quitar",
            'SAVE': "Guardar",
            'CANCEL': "Cancelar",
            'OPENS': "Abre",
            'CLOSES': "Cierra",
            'OPENS_AT': "Abre a las",
            'CLOSES_AT': "y cierra a las",
            'SUN': "Domingo",
            'MON': "Lunes",
            'TUE': "Martes",
            'WED': "Miércoles",
            'THU': "Jueves",
            'FRI': "Viernes",
            'SAT': "Sábado",
            'SU': 'D',
            'MO': 'L',
            'TU': 'M',
            'WE': 'M',
            'TH': 'J',
            'FR': 'V',
            'SA': 'S',
            'REMOVE_TIME_TEXT': "Si remueves el horario de servicio de este día, el restaurante no estará abierto en la app durante el día y algunas funciones no estarán disponibles",
            'REMOVE': "Quitar",
            'SAVING': "Guardando...",
        }
    }

    const auth = useSelector(state => state.Auth);
    const [restaurantWeekdays, setRestaurantWeekdays] = useState([]);
    const [saving, setSaving] = useState(false);
    const [days, setDays] = useState([{
        index: 'SU',
        code: 'SUN',
        selected: false
    }, {
        index: 'MO',
        code: 'MON',
        selected: false
    }, {
        index: 'TU',
        code: 'TUE',
        selected: false
    }, {
        index: 'WE',
        code: 'WED',
        selected: false
    }, {
        index: 'TH',
        code: 'THU',
        selected: false
    }, {
        index: 'FR',
        code: 'FRI',
        selected: false
    }, {
        index: 'SA',
        code: 'SAT',
        selected: false
    }]);
    const [isWeekdayTimeModalOpen, setIsWeekdayTimeModalOpen] = useState(false);
    const [form, setForm] = useState({
        controls: {
            RWE_START_TIME: {
                elementType: 'time',
                label: TServiceTimeSection[AppConfig.lang].OPENS + '*',
                elementConfig: {
                    placeholder: '07:00',
                    autoCapitalize: 'none'
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 5,
                },
                className: "col-6",
                valid: false,
                touched: false,
            },
            RWE_END_TIME: {
                elementType: 'time',
                label: TServiceTimeSection[AppConfig.lang].CLOSES + '*',
                elementConfig: {
                    placeholder: '22:00',
                    autoCapitalize: 'none'
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 5,
                },
                className: "col-6",
                valid: false,
                touched: false,
            },
        },
    });

    const [alertState, setAlertState] = useState({
        alertVisible: false,
        alertTitle: '',
        alertText: '',
        alertButtons: []
    });

    const RemoveWeekdayTime = async (item) => {
        setAlertState({
            alertVisible: true,
            alertTitle: TServiceTimeSection[AppConfig.lang].REMOVE_TIME,
            alertText: TServiceTimeSection[AppConfig.lang].REMOVE_TIME_TEXT,
            alertButtons: [{
                text: TServiceTimeSection[AppConfig.lang].CANCEL,
                onPress: () => {
                },
                style: "cancel"
            },
                {
                    text: TServiceTimeSection[AppConfig.lang].REMOVE,
                    onPress: async () => {
                        let updatedRestaurantWeekdays = [...restaurantWeekdays];
                        let restaurantIndex = updatedRestaurantWeekdays.findIndex(i => i.rwE_ID == item.rwE_ID);

                        if (restaurantIndex == -1) {
                            return;
                        }

                        updatedRestaurantWeekdays[restaurantIndex].removing = true;
                        setRestaurantWeekdays(updatedRestaurantWeekdays);

                        const response = await fetch(AppConfig.URL + "/Restaurant/RemoveRestaurantWeekday/" + item.rwE_ID, {
                            method: 'GET',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': auth.token
                            }
                        });

                        const json = await response.json();

                        if (json.success) {
                            updatedRestaurantWeekdays = [...restaurantWeekdays]
                            updatedRestaurantWeekdays.splice(restaurantIndex, 1);

                            setRestaurantWeekdays(updatedRestaurantWeekdays)
                        }
                    }
                }]
        })
    };

    const ToggleWeekdayTimeModal = () => {
        setIsWeekdayTimeModalOpen(!isWeekdayTimeModalOpen);
    };

    useEffect(() => {
        setRestaurantWeekdays(props.restaurantWeekdays);
    }, [props.restaurantWeekdays])

    return (
        <View>
            {isWeekdayTimeModalOpen ?
                <div className={'card'} style={{marginBottom: 15}}>
                    <div className={'card-body'}>
                        <CCText style={{fontWeight: 'bold'}}>
                            {TServiceTimeSection[AppConfig.lang].NEW_SERVICE_TIME}
                        </CCText>
                        <ChocoForm
                            form={form}
                            lang={AppConfig.lang}
                            onFormChange={(updatedForm) => {
                                setForm(updatedForm);
                            }}
                            containerClassName={'row'}
                        />
                        <CCText style={{fontWeight: 'bold'}}>
                            {TServiceTimeSection[AppConfig.lang].APPLICABLE_DAYS}
                        </CCText>
                        <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>
                            {days.map(item => {
                                const style = {};

                                if (item.selected) {
                                    style.backgroundColor = '#f0f0f0';
                                    style.borderRadius = '50%'
                                }

                                return <TouchableNativeFeedback
                                    onPress={() => {
                                        const updatedDays = [...days];
                                        const index = days.findIndex(i => i.code === item.code);

                                        if (index > -1) {
                                            updatedDays[index].selected = !updatedDays[index].selected;

                                            setDays(updatedDays);
                                        }
                                    }}
                                >
                                    <View style={{
                                        flex: 1,
                                        padding: '7px 15px',
                                        justifyContent: 'center',
                                        alignItems: 'center', ...style
                                    }}>
                                        <CCText style={{fontSize: 20, textAlign: 'center'}}>
                                            {TServiceTimeSection[AppConfig.lang][item.index]}
                                        </CCText>
                                    </View>
                                </TouchableNativeFeedback>
                            })}
                        </View>
                        <View style={{marginTop: 15, flexDirection: 'row', justifyContent: 'flex-end'}}>
                            {saving ?
                                <View style={{flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center'}}>
                                    <CCText style={{...Styles.themeColor}}>
                                        {TServiceTimeSection[AppConfig.lang].SAVING}
                                    </CCText>
                                    <View style={{width: 7}}></View>
                                    <ActivityIndicator size={40}/>
                                </View>
                                :
                                <View style={{flexDirection: 'row', justifyContent: 'flex-end'}}>
                                    <BorderlessButton
                                        onPress={ToggleWeekdayTimeModal}
                                        text={TServiceTimeSection[AppConfig.lang].CANCEL}
                                    />
                                    <View style={{width: 7}}></View>
                                    <ThemeButton
                                        disabled={!form.isValidForm || days.filter(item => item.selected).length == 0}
                                        text={TServiceTimeSection[AppConfig.lang].SAVE}
                                        onPress={async () => {
                                            const controls = {...form.controls}

                                            if (form.isValidForm) {
                                                setSaving(true);
                                                const selectedDays = days.filter(item => item.selected);
                                                let formData = {};
                                                let insertedArray = [];

                                                formData["RWE_RESTAURANT_ID"] = props.RestaurantID;
                                                formData["RWE_START_TIME"] = controls.RWE_START_TIME.value;
                                                formData["RWE_END_TIME"] = controls.RWE_END_TIME.value;

                                                for (let i = 0; i < selectedDays.length; i++) {
                                                    const response = await fetch(AppConfig.URL + "/Restaurant/SetRestaurantWeekdayTimes/?WeekdayCode=" + selectedDays[i].code, {
                                                        method: 'POST',
                                                        headers: {
                                                            'Accept': 'application/json',
                                                            'Content-Type': 'application/json',
                                                            'Authorization': auth.token
                                                        },
                                                        body: JSON.stringify(formData)
                                                    });

                                                    const json = await response.json();

                                                    if (json.success) {
                                                        insertedArray.push(json.restaurantWeekday);
                                                    }
                                                }

                                                const updatedRestaurantWeekdays = [...restaurantWeekdays];

                                                for (let i = 0; i < insertedArray.length; i++) {
                                                    const restaurantIndex = updatedRestaurantWeekdays.findIndex(item => {
                                                        return item.weekday?.wdA_CODE === insertedArray[i].weekday.wdA_CODE
                                                    });

                                                    if (restaurantIndex > -1) {
                                                        updatedRestaurantWeekdays[restaurantIndex] = insertedArray[i];
                                                    } else {
                                                        updatedRestaurantWeekdays.push(insertedArray[i]);
                                                    }
                                                }

                                                setRestaurantWeekdays(updatedRestaurantWeekdays);
                                                setSaving(false);
                                                ToggleWeekdayTimeModal();
                                            } else {
                                                ToggleWeekdayTimeModal();
                                            }
                                        }}
                                    />
                                </View>
                            }
                        </View>
                    </div>
                </div>
                :
                <View style={{justifyContent: 'center', ...Styles.sasPadding, ...Styles.flexDirectionRow}}>
                    <ThemeButton
                        onPress={ToggleWeekdayTimeModal}
                        text={TServiceTimeSection[AppConfig.lang].SET_TIME}
                    />
                </View>
            }
            {restaurantWeekdays.map(item => {
                if (item.rwE_START_TIME && item.rwE_END_TIME) {
                    return <View
                        key={item.rwE_ID}
                        style={{marginBottom: 15}}
                    >
                        <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>
                            <CCText style={{...Styles.themeColor}}>
                                {TServiceTimeSection[AppConfig.lang][item.weekday.wdA_CODE]}
                            </CCText>
                            {item.removing ?
                                <ActivityIndicator
                                    size={27}
                                />
                                :
                                <BorderlessButton
                                    onPress={() => RemoveWeekdayTime(item)}
                                    text={TServiceTimeSection[AppConfig.lang].REMOVE_TIME}
                                    style={{padding: 0}}
                                    textStyle={{...Styles.redColor}}
                                />
                            }
                        </View>
                        <CCText style={{fontSize: 19}}>
                            {TServiceTimeSection[AppConfig.lang].OPENS_AT}
                            &nbsp;{item.rwE_START_TIME}&nbsp;
                            {TServiceTimeSection[AppConfig.lang].CLOSES_AT}
                            &nbsp;{item.rwE_END_TIME}&nbsp;
                        </CCText>
                    </View>;
                }
            })}
            <AlertModal
                visible={alertState.alertVisible}
                onRequestClose={() => setAlertState({...alertState, alertVisible: !alertState.alertVisible})}
                title={alertState.alertTitle}
                text={alertState.alertText}
                buttons={alertState.alertButtons}
            />
        </View>
    );
};